<div #root class="gridster-root">
  <gridster [options]="options">

    <gridster-item
      *ngFor="let w of widgets; let i = index"
      [item]="w.item"
      (click)="onItemClick(i)"
    >
      <ng-container *ngTemplateOutlet="w.template"></ng-container>
    </gridster-item>

  </gridster>
</div>